// Module
var code = `<template>
  <require from="./total-profit-loss-widget.scss"></require>
  <global-progress if.bind="loading" size="50" stroke-width="5"></global-progress>
  <!-- beautify ignore:start -->
  <style>
    .total-profit-loss-widget-\${id} {
      font-family: \${font || 'var(--dyn-default-font-family)'};
      font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
      color: \${color | widgetTemplateColor:isInDashboard} !important;
      text-align: \${textAlign || 'left'};
    }
  </style>
  <!-- beautify ignore:end -->

  <div class="total-profit-loss-widget total-profit-loss-widget-\${id}">
    <div if.bind="!loading && !error">\${profitLossTotal | numericFormatter:'a\$'}</div>

    <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;